import axios from 'axios'
import qs from 'qs'
// import store from '../store'
// var cookies = require('vue-cookies')
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.responseType = 'json'
// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 100000, // 请求超时时间
  paramsSerializer (params) { // 序列化函数
    qs.stringify(params)
  }
})

// POST传参序列化
service.interceptors.request.use((config) => {
  // cookies.set('theme', config.data.theme)
  if (config.data !== undefined) {
    if (config.data.theme === 'blue') {
      // 蓝色
      window.document.documentElement.setAttribute('data-theme', 'dark')
    } else if (config.data.theme === 'red') {
      // 红色
      window.document.documentElement.setAttribute('data-theme', 'light')
    }
  }
  // console.log(config, 'deep')
  if (config.key === 'deep') {

  } else {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
  }

  return config
}, (error) => {
  console.log(error)
  return Promise.reject(error)
})

service.interceptors.response.use(response => {
  const data = response.data
  if (data.code === 0) {
    return Promise.resolve(data)
  } else {
    console.log(data)
    return Promise.reject(data)
  }
}, error => {
  return Promise.reject(error)
})

export default service
